// extracted by mini-css-extract-plugin
export default {"chat":"SideChat_chat__d3pL3","message":"SideChat_message__-1tWr","link":"SideChat_link__2rm0j","roomName":"SideChat_roomName__1vq9-"};